import React, { useEffect } from "react";
import RegistrationForm from "../RegistrationForm/RegistrationForm";
import regbanner from "../../../assets/icons/regBanner.jpeg";
import { clientContinue, localStorageGetItem, parseQuery } from "../../Services/globalService";
import GlobalStore from "../../store/globalStore";
import "./RegistrationHome.scss";
import { AGetCities } from "../../Services/registration/registrationApiService";
import { containerUrl } from "../../utils/constants";
interface IRegistrationProps {
  location?: any;
  match?: any;
  navigate?: any;
}

const Registration: React.FC<IRegistrationProps> = (props) => {
  const [entitySubType, setEntitySubType] = React.useState<string | undefined>();

  useEffect(() => {
    init();
  }, [window.location.search]);

  const init = () => {
    let queryObject: any = {};

    try {
      const urlParams = new URLSearchParams(window.location.search);

      /** -------------------------
       *  NEW MERGED LOGIC: Decode ?data=
       *  -------------------------
       */
      const encodedData = urlParams.get("data");
      if (encodedData) {
        try {
          const decryptedQuery = atob(encodedData);
          const parsedQuery = JSON.parse(decryptedQuery);


          GlobalStore.entityType = parsedQuery?.EntityType;
          GlobalStore.entitySubType = parsedQuery?.EntitySubtype;
          GlobalStore.isOTCFlow = parsedQuery?.isotc;
          GlobalStore.isNriOtc = parsedQuery?.Isnri && parsedQuery?.isotc;
          GlobalStore.isNriInv = parsedQuery?.Isnri;
          setEntitySubType(parsedQuery?.EntitySubtype)

          queryObject = parsedQuery;

          // store for persistence if needed
          window.sessionStorage.setItem(
            "rmInvestmentLink",
            JSON.stringify(window.location.search)
          );

        } catch (error) {
          console.error("Failed to decode base64 query:", error);
          queryObject = parseQuery(window.location.search);
        }
      } else {
        queryObject = parseQuery(window.location.search);

        /** -------------------------
         *  Handle continue logic if no encoded data
         *  -------------------------
         */
        if (
          containerUrl.continue === clientContinue() &&
          !GlobalStore.isPartialFilledClient && !localStorageGetItem('isMultipleApplication')
        ) {
          props.navigate(containerUrl.continue);
        } else {
          AGetCities(() => { }); // your callback
        }
      }

      // Save emp code if present
      const empCode = urlParams.get("empCode");
      if (empCode) {
        window.sessionStorage.setItem("empCode", empCode);
      }
    } catch (error) {
      console.error("Error while parsing query params:", error);
    }

    setUTMParams(queryObject);
    onlyDematParam(queryObject);

    if (
      queryObject?.utm_source &&
      queryObject.utm_source.toUpperCase() === "LEADFORDSA"
    ) {
      GlobalStore.leadForDsa = true;
    }
  };

  const setUTMParams = (queryObject: any) => {
    if (Object.keys(queryObject).length > 0) {
      let objUTM_Info = {
        modeofapplication: "E",
        utm_source: queryObject.utm_source || queryObject.utmsource || "",
        utm_medium: queryObject.utm_medium || queryObject.utmmedium || "",
        utm_term: queryObject.utm_term || queryObject.utmterm || "",
        utm_creative: queryObject.utm_creative || queryObject.utmcreative || "",
        utm_campaign: queryObject.utm_campaign || queryObject.utmcampaign || "",
        utm_adgroup: queryObject.utm_adgroup || queryObject.utmadgroup || "",
        utm_placement:
          queryObject.utm_placement || queryObject.utmplacement || "",
        utm_device: queryObject.utm_device || queryObject.utmdevice || "",
        utm_content: queryObject.utm_content || queryObject.utmcontent || "",
        referralcode: "",
        couponcode: "",
        stageinfo: "",
        signupdropout: "",
        registrationdur: "",
        devicetype: "",
        clientip: "",
        diysource: "W",
        AssignedTo: queryObject?.AssignedTo || "",
        IsRM: queryObject?.IsRM,
      };
      const partner = props.match?.path === "/partner";
      window.sessionStorage.setItem("objUTM_Info", JSON.stringify(objUTM_Info));
      window.sessionStorage.setItem("partner", JSON.stringify(partner));
    }
  };

  const onlyDematParam = (queryObject: any) => {
    let objAccType = "EQTY";
    if (Object.keys(queryObject).length !== 0) {
      const accTypeValue = (queryObject.accType || queryObject.acctype || "").toUpperCase();

      if (accTypeValue === "DMT") {
        objAccType = "DMT";
      } else if (accTypeValue === "RMINV") {
        objAccType = "RMINV";
      }
    }

    window.sessionStorage.setItem("objAccType", objAccType);
    try {
      (window as any).mixpanel?.register({
        user_type: objAccType === "RMINV" ? "RM" : "client",
      });
    } catch (e) {
      console.error("mixpanel register failed", e);
    }
  };

  const subTypeName = (name: string) => {
    switch (name) {
      case "NRONonPIS":
        return "NRO Non-PIS";
      case "NREPIS":
        return "NRE PIS";
      case "NROPIS":
        return "NRO PIS";
      case "NRENonPIS":
        return "NRE Non-PIS";
      default:
        return name;
    }
  };

  return (
    <div className="registration">
      <div className="regInfo">
        <label>
          We are your personal wealth advisor. We aim to understand and
          simplify all your investment needs.
        </label>
      </div>
      {entitySubType &&
        <div className="regInfo">
          <h1 className="regEntityTitle">
            {entitySubType?.toLowerCase() === "indian"
              ? "Resident Indian"
              : `${subTypeName(entitySubType) || ""} Account`}
          </h1>
        </div>
      }
      <div className="banner">
        <img className="bannerImg" src={regbanner} alt="banner" />
      </div>
      <RegistrationForm {...props} />
    </div>
  );
}

export default Registration;